import React, { useState } from 'react';
import { Breadcrumb, Input, Button, Form, message } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { upPassword } from '../gqls'
import Client from '../../../../lib/gqlClient';
const SetPasswordPage = (props) => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false)
    const [isSatisfy, setIsSatisfy] = useState(false)

    const [oldPassword, setOldPassword] = useState('')
    const [newPassword, setNewPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')
    React.useEffect(() => {

    }, [])
    function onStart() {
        props.setNewKey('developerCenter/settings/profileSettings')
        navigate('/developerCenter/settings/profileSettings')
    }

    const onFinish = (values) => {
        const oldPassword = values.oldPassword
        const newPassword = values.newPassword
        const confirmPassword = values.confirmPassword
        if (oldPassword.length < 6 ||
            newPassword.length < 6 ||
            confirmPassword.length < 6) {
            //密码长度不符合
            message.error('Please enter 6-20 letters or numbers.')
            return
        }

        if (newPassword !== confirmPassword) {
            //新密码不一致
            message.error('Password confirmation doesn\'t match the password. ')
            return
        }

        setIsLoading(true)
        Client(
            '',
            {
                oldPwd: oldPassword,
                newPwd: newPassword,
            },
            upPassword
        ).then((res) => {
            console.log(res)
            if (res !== null && res.data.updatePassword) {
                message.success('Password changed successfully.')
                onStart()
            } else {
                message.error('Password changed failed.')
            }
            setIsLoading(false)
        }).catch(e => {
            // console.log(e);
            setIsLoading(false)
        })

    }
    const onFinishFailed = (errorInfo) => {
        console.log('onFinishFailed:', errorInfo);
    }
    const onValuesChange = (values) => {
        let type = 0
        let old = values.oldPassword
        let news = values.newPassword
        let con = values.confirmPassword
        if (old != null) {
            type = 1
            setOldPassword(old)
        } else {
            old = oldPassword
        }
        if (news != null) {
            type = 2
            setNewPassword(news)
        } else {
            news = newPassword
        }
        if (con != null) {
            type = 3
            setConfirmPassword(con)
        } else {
            con = confirmPassword
        }
        if (old.length >= 6 && news.length >= 6 && con.length >= 6) {
            setIsSatisfy(true)
        } else {
            setIsSatisfy(false)
        }

    }
    return (
        <div style={{ height: '100%', width: '100%', }}>
            <div style={{ minHeight: '437px', padding: '0px', backgroundColor: 'white', borderRadius: '2px' }}>
                {/* 标题头 */}
                <Breadcrumb style={{ marginLeft: '20px', paddingTop: "6px" }}>
                    <Breadcrumb.Item><Link to='../../../home' style={{ fontSize: '12px' }}>首页</Link></Breadcrumb.Item>
                    <Breadcrumb.Item><a onClick={onStart} style={{ fontSize: '12px' }}>Settings</a></Breadcrumb.Item>
                    <Breadcrumb.Item><a onClick={onStart} style={{ fontSize: '12px' }}>Profile Settings</a></Breadcrumb.Item>
                    <Breadcrumb.Item><a style={{ fontSize: '12px' }}>修改密码</a></Breadcrumb.Item>
                </Breadcrumb>
                <div style={{ fontSize: '20px', marginLeft: '150px', marginTop: '30px', marginBottom: '34px' }}>Change password</div>
                <Form
                    initialValues={{}}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    onValuesChange={onValuesChange}
                    autoComplete="off"
                    style={{ marginLeft: '232px' }}>
                    
                    <Form.Item style={{ padding: '0px', margin: '0px' }}>
                        <div style={{ fontSize: '14px', }}>Old password</div>
                    </Form.Item>
                    <Form.Item
                        label=""
                        name="oldPassword"
                        rules={[{ required: true, message: 'Please enter your old password!' }]}
                        style={{ padding: '0px', margin: '0px' }}>
                        <Input
                            style={{
                                width: '400px', marginTop: '4px', height: '31px',
                                paddingLeft: '10px', paddingRight: '10px',
                            }}
                            disabled={isLoading}
                            maxLength={20}
                            placeholder="Please enter your old password" />
                    </Form.Item>
                    
                    <Form.Item style={{ padding: '0px', margin: '0px' }}>
                        <div style={{ fontSize: '14px', marginTop: '24px' }}>New password</div>
                    </Form.Item>
                    <Form.Item
                        label=""
                        name="newPassword"
                        rules={[{ required: true, message: 'Please enter your new password!' }]}
                        style={{ padding: '0px', margin: '0px' }}
                        >
                        <Input
                            style={{
                                width: '400px', marginTop: '4px', height: '31px',
                                paddingLeft: '10px', paddingRight: '10px',
                            }}
                            disabled={isLoading}
                            maxLength={20}
                            placeholder="Please enter 6-20 letters or numbers" />
                    </Form.Item>
                   
                    <Form.Item style={{ padding: '0px', margin: '0px' }}>
                        <div style={{ fontSize: '14px', marginTop: '24px' }}>Confirm New password</div>
                    </Form.Item>
                    <Form.Item
                        label=""
                        name="confirmPassword"
                        rules={[{ required: true, message: 'Please confirm your new password!' }]}
                        style={{ padding: '0px', margin: '0px' }}>
                        <Input
                            style={{
                                width: '400px', marginTop: '4px', height: '31px',
                                paddingLeft: '10px', paddingRight: '10px',
                            }}
                            disabled={isLoading}
                            maxLength={20}
                            placeholder="Please enter 6-20 letters or numbers" />
                    </Form.Item>

                    <Form.Item style={{ padding: '0px', margin: '0px' }}>
                        <Button disabled={isLoading} style={{
                            marginTop: '30px', marginLeft: '240px', marginBottom: '30px', height: '32px', width: '160px', color: '#fff',
                            background: isSatisfy ? '#FF5300' : '#D8D8D8', display: 'flex', justifyContent: 'center', alignItems: 'center',
                        }} htmlType="submit">
                            <div style={{ display: isLoading ? 'none' : 'contents', color: isSatisfy ? '#FFFFFF' : '#707070' }}>Update password</div>
                            <div style={{ display: isLoading ? 'contents' : 'none', }}>
                                <img class='img' style={{ width: '20px', height: '20px' }} src={require('../../../../static/img/ic-login-loading.png')} />
                            </div>
                        </Button>
                    </Form.Item>
                </Form>
            </div>

        </div>
    );

}

export default SetPasswordPage